import { useApolloClient } from "@apollo/client";
import DataTable from "@mostrans/web-components/components/advanced/DataTable";
import Button from "@mostrans/web-components/components/base/Button";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import { useConfirmationModal } from "@mostrans/web-components/hooks/useConfirmationModal";
import { Paper } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useSetRecoilState } from "recoil";
import {
  CreateMasterDivision, DeleteMasterDivisionByID, UpdateMasterDivisionByID
} from "../../../../GQL/mutations";
import Title from "../../../../components/Layout/Title";
import { titleAtoms } from "../../../../shared/atoms/titleAtoms";
import { useGetMasterDivision } from "../../../../shared/hooks/useGetMasterData";

function Division() {
  const [listDivision, fetchMasterDivision] = useGetMasterDivision();
  const [inputDivision, setInputDivision] = useState("");
  const [errInput, setErrInput] = useState(false);
  const client = useApolloClient();
  const { showConfirmationModal } = useConfirmationModal();
  // const {  } = useConfirmationModal();
  const [openModalUpdateDivision, setOpenModalUpdateDivision] = useState(false);
  const [valueUpdate, setValueUpdate] = useState();
  const setTitle = useSetRecoilState(titleAtoms);

  useEffect(() => {
    setTitle("Division");
  }, []);

  const handleClearValueOnState = () => {
    setInputDivision("");
    setValueUpdate("");
  };

  const handleOpenModalUpdate = (data) => {
    setOpenModalUpdateDivision(true);
    setValueUpdate(data);
  };

  const handleCloseModalUpdate = () => {
    setOpenModalUpdateDivision(false);
    setErrInput(false);
  };

  const column = [
    {
      getCellKey: (data) => <p style={{ fontSize: 12 }}>{data?.division}</p>,
      selector: "division",
      header: "Division Name",
      sortBy: "division",
      sortable: true,
    },
    {
      renderCell: (data) => (
        <>
          <Button onClick={() => handleOpenModalUpdate(data)}>Detail</Button>
          <Button color="error" onClick={() => submitDeleteDivision(data)}>
            Delete
          </Button>
        </>
      ),
      selector: "id",
      header: "Action",
    },
  ];
  const submitDivision = async () => {
    const show = await showConfirmationModal({
      // headerText: "Confirmation",
      // deniedButtonText: "Cancel",
      // confirmButtonText: "Confirm",
      // headerIcon: <Icon>warning</Icon>,
      contentText: "Are you sure to add a new division?",
      // modalProps: {},
    });

    if (show.isConfirmed) {
      if (!inputDivision) {
        setErrInput(true);
      }
      try {
        const responInput = await CreateMasterDivision(client, {
          division: inputDivision,
        });

        if (responInput.data.createMasterDivision.errMsg === "OK") {
          toast.success("Division Submitted", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setErrInput(false);
          fetchMasterDivision();
          setInputDivision("");
        } else {
          toast.error("Submit Failed", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } catch (error) {
        console.log(error, "Error Input Division");
        alert("Submit Failed");
      }
    }

    if (show.isDenied) {
    }
  };

  const submitUpdateDivision = async () => {
    if (!inputDivision) {
      setErrInput(true);
    }
    const paramUpdate = {
      id: parseInt(valueUpdate.id),
      division: inputDivision,
    };
    try {
      const responUpdate = await UpdateMasterDivisionByID(client, paramUpdate);

      if (responUpdate.data.updateMasterDivisionByID.errMsg === "OK") {
        toast.success("Division Updated", {
          position: toast.POSITION.TOP_RIGHT,
        });
        fetchMasterDivision();
        handleClearValueOnState();
        setErrInput(false);
        handleCloseModalUpdate();
      } else {
        toast.error("Update Failed", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      setErrInput(false);
    } catch (error) {
      alert(error);
      console.log(error);
    }
  };

  const submitDeleteDivision = async (data) => {
    const show = await showConfirmationModal({
      contentText: "Are you sure to delete division?",
    });
    
    if (show.isConfirmed) {
      try {
        const responDelete = await DeleteMasterDivisionByID(client, data.id);
        if (responDelete.data.deleteMasterDivisionByID.errMsg === "OK") {
          toast.success("Division deleted", {
            position: toast.POSITION.TOP_RIGHT,
          });
          fetchMasterDivision();
        } else {
          toast.error("Delete Failed", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } catch (error) {
        alert(error);
      }
    }
  };
  return (
    <React.Fragment>
      <Dialog open={openModalUpdateDivision} onClose={handleCloseModalUpdate}>
        <DialogTitle>Update Division</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <FormGroup>
              <Input
                defaultValue={valueUpdate?.division}
                error={errInput}
                style={{ width: "400px" }}
                onChange={(e) => setInputDivision(e.target.value)}
              />
            </FormGroup>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={handleCloseModalUpdate}>
            Cancel
          </Button>
          <Button onClick={submitUpdateDivision}>Submit</Button>
        </DialogActions>
      </Dialog>
      {/* <ConfAddDivision /> */}
      {/* <ConfDeleteDivison /> */}
      <ToastContainer />
      <div>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}>
          <Title>Division Master</Title>
          <div className="form-row">
            <div className="col-md-6">
              <FormGroup>
                <Input
                  defaultValue={inputDivision}
                  onChange={(e) => setInputDivision(e.target.value)}
                  error={errInput}
                />
              </FormGroup>
            </div>
            <div className="col md-6">
              <Button variant="contained" onClick={submitDivision} color="primary">
                Add Division
              </Button>
            </div>
          </div>
          <div className="mt-2">
            <DataTable data={listDivision} columns={column} hasPagination={true} />
          </div>
        </Paper>
      </div>
    </React.Fragment>
  );
}

export default Division;
